<h2 mat-dialog-title>
    {{ isEditMode ? 'Editar Usuário' : 'Criar Novo Usuário' }}
    @if (contextName) {
    <span> para {{ contextName }}</span>
    }
</h2>

<mat-dialog-content>
    <form [formGroup]="form" class="user-form">
        <div class="name-fields">
            <mat-form-field>
                <mat-label>Nome</mat-label>
                <input matInput formControlName="firstName" required cdkFocusInitial />
            </mat-form-field>
            <mat-form-field>
                <mat-label>Sobrenome</mat-label>
                <input matInput formControlName="lastName" />
            </mat-form-field>
        </div>

        <mat-form-field>
            <mat-label>Login (nome de usuário)</mat-label>
            <input matInput formControlName="login" required />
            @if (data.lockLogin) {
            <mat-hint>Login = código APC do produtor</mat-hint>
            }
        </mat-form-field>

        <mat-form-field>
            <mat-label>E-mail</mat-label>
            <input matInput formControlName="email" type="email" required />
        </mat-form-field>

        <mat-form-field>
            <mat-label>Senha</mat-label>
            <input matInput formControlName="password" type="password" />
            @if (isEditMode) {
            <mat-hint>Deixe em branco para não alterar a senha</mat-hint>
            }
        </mat-form-field>
    </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()">Cancelar</button>
    <button mat-raised-button color="primary" (click)="onSave()" [disabled]="form.invalid">
        Salvar
    </button>
</mat-dialog-actions>
